import type { ErpConfigResponse } from "@common/client"

export function hasCorridorErp(config: ErpConfigResponse): boolean {
  return config.configured && config.vendor === "corridor"
}
